import {assertNotNull} from "../../js/util/CommonUtils.js";

const STRUCTURE_ID_TITLE_CLASS = 'structure-grid__title';

export default class StructureGridHtml {
    /** @type {HTMLElement}*/
    #root;
    /** @type {Map<Element, StructureId>} */
    #structureIds = new Map();
    /** @type {Map<StructureId, Element>} */
    #cards = new Map();
    /** @type {Function} */
    #onCardTitleClickedCb;
    /** @type {Function} */
    #onDeleteClickCb;


    /** @param {HTMLElement} parent */
    init(parent) {
        parent.insertAdjacentHTML('beforeend', this.#template());
        this.#root = parent.lastElementChild;
    }

    /**
     * @param {StructureId} structureId
     * @param {StructureForms} forms
     */
    addCard(structureId, forms) {
        const cardHtml = this.#cardTemplate(this.#imgTemplate(structureId.imgRef, forms.size, forms.sizeSelected));
        this.#root.insertAdjacentHTML('beforeend', cardHtml);
        const cardElement = this.#root.lastElementChild;
        this.#structureIds.set(cardElement, structureId);
        this.#cards.set(structureId, cardElement);
        const title = this.#getCardTitleElement(cardElement);
        title.addEventListener('click', this.#onCardTitleClicked.bind(this));
        const deleteBtn = this.#getDeleteBtn(cardElement);
        deleteBtn.addEventListener('click', this.#onDeleteClick.bind(this, structureId, cardElement));
    }
    /**
     * @param {StructureId} structureId
     * @param {StructureForms} forms
     */
    updateCard(structureId, forms) {
        const card = this.#cards.get(structureId);
        const label = this.#getCardTitleElement(card);
        label.innerText = this.#formCountText(forms.size, forms.sizeSelected);
    }
    /** @return {HTMLElement} */
    addLastCard() {
        // Even though we use afterbegin and the card actually goes first inside DOM, we can change its
        // order using CSS.
        this.#root.insertAdjacentHTML('afterbegin', this.#cardTemplate(''));
        const lastCard = this.#root.lastElementChild;
        lastCard.classList.add('structure-grid__item--last')
        return lastCard;
    }

    /** @param {function} cb */
    onCardTitleClicked(cb) {
        this.#onCardTitleClickedCb = cb;
    }

    /** @param {function} cb */
    onDelete(cb){
        this.#onDeleteClickCb = cb
    }

    #onCardTitleClicked(evt) {
        const element = evt.target.parentElement;
        const structureId = this.#structureIds.get(element);
        if(!structureId)
            throw new Error("Couldn't find Structure ID for this HTML element: " + element);
        this.#onCardTitleClickedCb && this.#onCardTitleClickedCb(structureId);
    }

    /**
     * @param {StructureId} structureId
     * @param {HTMLElement} cardElement
     */
    #onDeleteClick(structureId, cardElement ){
        cardElement.remove();
        this.#onDeleteClickCb(structureId);
    }

    /**
     * @param {HTMLElement} card
     * @return {HTMLElement}
     */
    #getCardTitleElement(card) {
        return card.querySelector('.' + STRUCTURE_ID_TITLE_CLASS);
    }

    /**
     * @param {HTMLElement} card
     * @return {HTMLElement}
     */
    #getDeleteBtn(card) {
        return card.querySelector('[data-action="delete"]');
    }

    /** @returns {string} */
    #template() {
        return `<section class="structure-grid"></section>`;
    }

    /**
     * @param {string} childHtml
     * @returns {string}
     */
    #cardTemplate(childHtml) {
        return `<div class="structure-grid__item">${childHtml}</div>`;
    }

    /**
     * @param {string} imgRef
     * @param {number} formCount
     * @param {number} formsSelected
     * @returns {string}
     */
    #imgTemplate(imgRef, formCount, formsSelected) {
        const title = this.#formCountText(formCount, formsSelected);
        return `
                <span data-action="delete" class="structure-grid__delete-icon material-icons">delete_outlined</span>
                <img src="${imgRef}" alt="structure" width="250" height="250">
                <span class="${STRUCTURE_ID_TITLE_CLASS} link">${title}</span>
              `;
    }

    /**
     * @param {number} formCount
     * @param {number} formsSelected
     * @returns {string}
     */
    #formCountText(formCount, formsSelected) {
        assertNotNull(formCount);
        return formsSelected +"/" + formCount + " forms";
    }
}